import React from 'react';
import { AtSignIcon, MailIcon } from 'lucide-react';
import { ColombiaFlag } from '../ColombiaFlag';
import { CtaButton } from '../CtaButton';
import { checkoutUrl, contact, paymentMethods } from '../../data/landing';
export function Footer() {
  return <footer className="border-t border-line bg-surface px-5 py-14" data-id="element-125" data-mp="2f2qxzc42qt7e">
      <div className="mx-auto max-w-3xl text-center" data-id="element-126" data-mp="2a71uwysuiu6c">
        <p className="text-2xl font-black leading-snug text-heading md:text-3xl" data-id="element-127" data-mp="1mg5x9l1pl4r6">
          “La atención es tuya. La vida es tuya. <span className="text-accent" data-id="element-128" data-mp="1hhulh4rusk6b">Empieza hoy.</span>”
        </p>
        <div className="mt-8 flex justify-center" data-id="element-129" data-mp="1w5z5qd6k13r7">
          <CtaButton href={checkoutUrl} data-id="element-130" data-mp="1w6r23q7z75ij">Quiero mi MegaPack ahora</CtaButton>
        </div>

        <div className="mt-14 border-t border-line pt-10" data-id="element-131" data-mp="1re7nqr1gs6co">
          <p className="flex items-center justify-center gap-3 text-xl font-black uppercase tracking-[0.15em] text-heading" data-id="element-132" data-mp="13pogmeu5hzm6">
            <ColombiaFlag className="h-4 w-6" data-id="element-133" data-mp="yrd6e2zy1n3f" />
            Hábil Online™
          </p>
          <p className="mt-4 text-base text-heading/90" data-id="element-134" data-mp="1eilsisup8lvc">
            El sistema de rescate digital N°1 para personas con adicción al scroll en Colombia.
          </p>
          <p className="mt-1 text-sm text-body" data-id="element-135" data-mp="1ihb36docrpba">
            Porque recuperar tu atención no debería costarte tu productividad y tu paz mental.
          </p>
          <p className="mt-4 text-sm text-body" data-id="element-136" data-mp="1s8fkhk1i3m9a">{paymentMethods}</p>
          <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-137" data-mp="vjhpc0pu9mbl">
            <li data-id="element-138" data-mp="zkthoe03klnh">
              <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-heading transition-colors duration-150 ease-out hover:text-success" data-id="element-139" data-mp="zk9xeqmz5l6a">
                <MailIcon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-140" data-mp="14lzaebtrc8x0" />
                {contact.email}
              </a>
            </li>
            <li data-id="element-141" data-mp="2fzup5jgr2fnp">
              <a href={`https://instagram.com/${contact.instagram.replace('@', '')}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-heading transition-colors duration-150 ease-out hover:text-success" data-id="element-142" data-mp="2fy9t1peseonq">
                <AtSignIcon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-143" data-mp="1vc3ig681ed90" />
                {contact.instagram}
              </a>
            </li>
          </ul>
          <p className="mt-10 text-xs leading-relaxed text-body/70" data-id="element-144" data-mp="25757z3685hc4">
            © Aprende y Emprende Online™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}